import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Grid, RichText, TAGTypography } from '../..';

function sortPricingLists(facilityData, groupList, pricingList) {
  var grouped = groupList.reduce(function (groups, group) {
    groups[group] = [];
    return groups;
  }, {});
  return pricingList.reduce(function (sorted, price) {
    var _facilityData$service;

    var service = (_facilityData$service = facilityData.services) === null || _facilityData$service === void 0 ? void 0 : _facilityData$service.find(function (service) {
      return service.procedureCode === price.procedureCode;
    });
    var promotionalPrice = Math.ceil(service === null || service === void 0 ? void 0 : service.promotionalPrice);

    if (sorted.grouped[price.group]) {
      var pricingIndex = sorted.grouped[price.group].findIndex(function (el) {
        return el.title === price.title;
      });

      if (pricingIndex === -1) {
        sorted.grouped[price.group].push(_objectSpread(_objectSpread({}, price), {}, {
          list: [{
            description: {
              description: ''
            },
            label: price.label,
            price: promotionalPrice
          }]
        }));
      } else {
        sorted.grouped[price.group][pricingIndex].list.forEach(function (el) {
          el.description.description = price.description.description;
        });
        sorted.grouped[price.group][pricingIndex].list.push({
          description: {
            description: price.description.description
          },
          label: price.label,
          price: promotionalPrice
        });
      }
    } else {
      sorted.other.push(_objectSpread(_objectSpread({}, price), {}, {
        price: promotionalPrice
      }));
    }

    return sorted;
  }, {
    grouped: grouped,
    other: []
  });
}

var FacilityPricing = function FacilityPricing(_ref) {
  var branding = _ref.branding,
      facilityData = _ref.facilityData,
      groupList = _ref.groupList,
      pricingList = _ref.pricingList,
      supplementalText = _ref.supplementalText;
  var sortedPricingLists = sortPricingLists(facilityData, groupList, pricingList);
  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true,
    spacing: 2,
    p: {
      xs: '20px'
    }
  }, sortedPricingLists.other.map(function (pricing) {
    return React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      lg: 2,
      key: pricing.contentful_id
    }, React.createElement("p", null, React.createElement(TAGTypography, {
      variant: "bodyMediumBold"
    }, pricing.title), React.createElement("br", null), React.createElement(TAGTypography, {
      variant: "bodyMediumBook"
    }, pricing.description.description, pricing.price)));
  })), Object.keys(sortedPricingLists.grouped).map(function (group) {
    return React.createElement(Grid, {
      key: group,
      container: true,
      p: {
        xs: '20px'
      }
    }, React.createElement(TAGTypography, {
      variant: "h3"
    }, group), sortedPricingLists.grouped[group].map(function (pricing) {
      return React.createElement("div", {
        key: pricing.contentful_id
      }, React.createElement("p", null, React.createElement(TAGTypography, {
        variant: "bodyLargeBold"
      }, pricing.title), React.createElement("br", null), React.createElement(TAGTypography, {
        variant: "bodyMediumBook"
      }, pricing.description.description), React.createElement("br", null), React.createElement(Grid, {
        container: true,
        spacing: 2
      }, pricing.list.map(function (pricingListItem, index) {
        return React.createElement(Grid, {
          item: true,
          xs: "auto",
          key: "".concat(pricing.contentful_id, "-pricing").concat(index)
        }, React.createElement(TAGTypography, {
          variant: "bodyMediumBook"
        }, pricingListItem.label), React.createElement("br", null), React.createElement(TAGTypography, {
          variant: "bodyMediumBook"
        }, pricingListItem.description.description, pricingListItem.price));
      }))));
    }));
  }), React.createElement(RichText, _objectSpread(_objectSpread({}, supplementalText), {}, {
    centerAlign: false,
    branding: branding
  })));
};

export default FacilityPricing;